<template>
  <div class="whole">
    <div class="search">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="valueYear" multiple collapse-tags clearable filterable :placeholder="$t('placeholder.Year1')" @change="indexSearch(valueYear)">
            <el-option
                v-for="item in optionsYear"
                :key="item.value"
                :label="item.label"
                :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <!--   这是该年份下的指标     -->
<!--   //备选：用于非体系指标查询     -->
<!--        <el-form-item>-->
<!--          <el-select v-model="valueIndex" multiple collapse-tags clearable filterable placeholder="指标（可多选）" style="width: 250px">-->
<!--            <el-option-->
<!--                v-for="item in optionsIndex"-->
<!--                :key="item.id"-->
<!--                :label="item.name_cn"-->
<!--                :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-cascader
              collapse-tags
              clearable
              filterable
              :placeholder="$t('placeholder.Index1')"
              :props="{checkStrictly: true,multiple: true}"
              :options="optionsIndex"
              v-model="valueIndex">
          </el-cascader>
        </el-form-item>

        <el-form-item>
          <el-cascader
              collapse-tags
              clearable
              filterable
              :placeholder="$t('placeholder.City4')"
              :options="optionsCity"
              :props="{multiple: true}"
              v-model="valueCity"
              style="width: 250px"
          ></el-cascader>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="dataSearch(valueIndex,valueCity)">{{ $t("button.Search") }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <el-table
          :data="detailData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
          :header-cell-style="{'text-align':'center'}"
          :cell-style="{'text-align':'center'}"
          border
          style="width: 100%">
        <el-table-column
            prop="eva_index.year"
            :label="$t('label.IndexYear')">
        </el-table-column>
        <el-table-column
            :prop=this.CityName
            :label="$t('label.CityName')">
        </el-table-column>
        <el-table-column
            :prop=this.IndexName
            :label="$t('label.IndexName')">
        </el-table-column>
        <el-table-column
            prop="value"
            :label="$t('label.Value')">
        </el-table-column>
        <el-table-column
            prop="score"
            :label="$t('label.Score')">
        </el-table-column>

        <template slot="empty">
          <p>{{$t("label.empty")}}</p>
        </template>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
          background
          layout="prev, pager, next"
          @current-change="current_change"
          :page-size="pagesize"
          :total="detailData.length">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "detailDataSearch",
  data() {
    return {
      CityName:'',
      IndexName:'',
      detailData:[],
      optionsYear: [],
      optionsCity: [],
      optionsIndex: [],
      valueYear: [],
      valueCity:[],
      valueIndex: [],

      pagesize:10,//每页的数据条数
      currentPage:1,//默认开始页面
    }
  },
  methods: {
    //监测当前页面
    current_change:function(currentPage){
      this.currentPage = currentPage;
    },
    indexSearch(valueYear){
      this.optionsIndex= []
      this.valueIndex=""
      this.$forceUpdate();

      for(let i=0;i<valueYear.length;i++){
        if(valueYear[i] === '2019' || valueYear[i] === '2020'){
          request.get('/dataquery/evaSys?year='+valueYear[i]).then(result => {
            var List = []
            var one={}
            var two={}
            var three={}
            var temp=[]
            var temp1=[]
            var sum={
              label:'',
              value:'',
              children:[]
            }
            if(this.$i18n.locale==='cn'){
              sum.label=result.data[0].name_cn+result.data[0].year
            }
            else{
              sum.label=result.data[0].name_en+result.data[0].year
            }
            sum.value=result.data[0].id
            List = result.data[0].children

            for(let i=0;i<List.length;i++){
              one={
                label:'',
                value:'',
                children:[]
              }
              if(this.$i18n.locale==='cn'){
                one.label = List[i].name_cn
              }
              else{
                one.label = List[i].name_en
              }
              one.value = List[i].id
              temp = List[i].children

              for(let j=0;j<temp.length;j++){
                two={
                  label:'',
                  value:'',
                  children:[]
                }
                if(this.$i18n.locale==='cn'){
                  two.label=temp[j].name_cn
                }
                else{
                  two.label=temp[j].name_en
                }
                two.value=temp[j].id
                one.children.push(two)
                temp1 = temp[j].children

                for(let k=0;k<temp1.length;k++){
                  three = {
                    label:'',
                    value:''
                  }
                  if(this.$i18n.locale==='cn'){
                    three.label = temp1[k].name_cn
                  }
                  else{
                    three.label = temp1[k].name_en
                  }
                  three.value = temp1[k].id
                  two.children.push(three)
                }
              }
              sum.children.push(one)
            }
            this.optionsIndex.push(sum)
            console.log(this.optionsIndex)
          }).catch(err => {
            console.log(err)
          })
        }
        else{
          request.get('/dataquery/evaSys?year='+valueYear[i]).then(result => {
            var List = []
            var one={}
            var two={}
            var temp=[]
            var sum={
              label:'',
              value:'',
              children:[]
            }
            if(this.$i18n.locale==='cn'){
              sum.label=result.data[0].name_cn+result.data[0].year
            }
            else{
              sum.label=result.data[0].name_en+result.data[0].year
            }
            sum.value=result.data[0].id
            List = result.data[0].children

            for(let i=0;i<List.length;i++){
              one={
                label:'',
                value:'',
                children:[]
              }
              if(this.$i18n.locale==='cn'){
                one.label = List[i].name_cn
              }
              else{
                one.label = List[i].name_en
              }
              one.value = List[i].id
              temp = List[i].children
              for(let j=0;j<temp.length;j++){
                two={
                  label:'',
                  value:''
                }
                if(this.$i18n.locale==='cn'){
                  two.label=temp[j].name_cn
                }
                else{
                  two.label=temp[j].name_en
                }
                two.value=temp[j].id
                one.children.push(two)
              }
              sum.children.push(one)
            }
            this.optionsIndex.push(sum)
          }).catch(err => {
            console.log(err)
          })
        }
        //备选：用于非体系指标查询
        // request.get("/EvaIndex?year="+valueYear[i]).then(result => {
        //   this.optionsIndex=Array.from(new Set([...this.optionsIndex, ...result.data]));
        // }).catch(err => {
        //   console.log(err)
        // })
      }
    },
    dataSearch(valueIndex,valueCity){
      if(valueIndex===''){
        if(this.$i18n.locale==='cn'){
          alert("请选择查询指标！")
        }
        else{
          alert("Please select query index!")
        }
      }
      if(valueCity==''){
        if(this.$i18n.locale==='cn'){
          alert("请选择查询城市！")
        }
        else{
          alert("Please select query city！")
        }
      }
      var indexString=''
      this.detailData=[]
      //外层循环所有城市
      for(let j=0;j<valueCity.length;j++){
        for(let i=0;i<valueIndex.length;i++){
          //内层循环把指标id放在一起
          var ind=valueIndex[i].length-1
          indexString=indexString+"&eva_indexsId="+valueIndex[i][ind]
        }
        //这里放request.get；能够提高查询效率
        request.get('/dataquery/detail?citiesId='+valueCity[j][2]+indexString).then(result => {
          this.detailData = this.detailData.concat(result.data)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    getCitys(){
      var that=this
      var continent={}
      var country={}
      var city={}
      request.get('/continent').then(async function (res){
        for(let i=0;i<res.data.length;i++){
          let continentItem=res.data[i]
          continent={
            label:'',
            value:'',
            children:[]
          }
          if(that.$i18n.locale==='cn'){
            continent.label=continentItem.name_cn
          }
          else{
            continent.label=continentItem.name_en
          }
          continent.value=continentItem.id

          //根据洲id获取国家，存在临时country字典中，并push到continent的children列表中
          await request.get('/country?continent_id='+continentItem.id).then(async function (res1){
            for(let j=0;j<res1.data.length;j++){
              let countryItem=res1.data[j]
              country={
                label:'',
                value:'',
                children:[]
              }
              if(that.$i18n.locale==='cn'){
                country.label=countryItem.name_cn
              }
              else{
                country.label=countryItem.name_en
              }
              country.value=countryItem.id
              //根据国家id获取城市，存在临时city字典中，并push到country的children列表中
              await request.get('city?country_id='+countryItem.id).then(function (res2){
                for(let k=0;k<res2.data.length;k++){
                  let cityItem=res2.data[k]
                  city={
                    label:'',
                    value:'',
                  }
                  if(that.$i18n.locale==='cn'){
                    city.label=cityItem.name_cn
                  }
                  else{
                    city.label=cityItem.name_en
                  }
                  city.value=cityItem.id
                  country.children.push(city)
                }
                continent.children.push(country)
              }).catch(function (err2){
                console.log(err2)
              })
            }
          }).catch(function (err1){
            console.log(err1)
          })
          that.optionsCity.push(continent)
        }
      }).catch(function (err){
        console.log(err)
      })
    }
  },
  mounted() {
    this.optionsYear= JSON.parse(window.sessionStorage.getItem('years'))
    this.getCitys()
  },
  created() {
    if(this.$i18n.locale==='cn'){
      this.CityName="city.name_cn"
      this.IndexName="eva_index.name_cn"
    }
    else{
      this.CityName="city.name_en"
      this.IndexName="eva_index.name_en"
    }
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
</style>